export const EMPLOYMENT_HEADER_TABS = [
  { id: "offres", label: "Offres" },
  { id: "missions", label: "Missions" },
  { id: "remote", label: "Télétravail" },
  { id: "alternance", label: "Alternance" },
  { id: "recrutement", label: "Recrutement" },
];

export const EMPLOYMENT_ACTION_IDS = [
  "offres", "profil", "alertes", "candidatures", "comparateur",
  "intelligence", "passeport", "mobilite", "observatoire", "opportunites",
  "salon", "embauche", "carriere-plus", "equilibre", "assistant", "reseau",
  "securite",
];

export const EMPLOYMENT_RECRUITER_ACTION_IDS = [
  "recrutement", "pipeline", "talents", "embauche-recruteur", "entreprise",
  "confiance", "responsable",
];

export const EMPLOYMENT_ACTION_STATUSES = Object.freeze({
  available: "Disponible",
  login_required: "Connexion requise",
  configuration_required: "Configuration nécessaire",
  coming_soon: "Bientôt disponible",
});

export function employmentActionDestination(actionId, recruiterMode = false) {
  const allowed = recruiterMode ? EMPLOYMENT_RECRUITER_ACTION_IDS : EMPLOYMENT_ACTION_IDS;
  const fallback = recruiterMode ? "recrutement" : "accueil";
  const tab = allowed.includes(actionId) || (!recruiterMode && actionId === "accueil")
    ? actionId
    : fallback;
  return recruiterMode
    ? `/market/emploi?tab=${encodeURIComponent(tab)}&mode=recruiter`
    : `/market/emploi?tab=${encodeURIComponent(tab)}`;
}

const EMPLOYMENT_DESTINATIONS = {
  offres: "/market/emploi?tab=offres",
  missions: "/market/emploi?tab=offres&category=freelance",
  remote: "/market/emploi?tab=offres&workplace=remote",
  alternance: "/market/emploi?tab=offres&category=alternance",
  recrutement: "/market/emploi?tab=recrutement",
};

export function employmentHeaderDestination(tab) {
  return EMPLOYMENT_DESTINATIONS[tab] || EMPLOYMENT_DESTINATIONS.offres;
}

export function employmentHeaderTab(search) {
  const params = new URLSearchParams(String(search || ""));
  if (String(params.get("tab") || "").trim().toLowerCase() === "recrutement") {
    return "recrutement";
  }
  const workplace = String(params.get("workplace") || "").trim().toLowerCase();
  const category = String(params.get("category") || "").trim().toLowerCase();
  if (workplace === "remote") return "remote";
  if (category === "freelance") return "missions";
  if (category === "alternance") return "alternance";
  return "offres";
}
